import { formControl, Validators } from '@al00x/forms';
import { Component, inject, signal } from '@angular/core';
import { PageEditorComponent, PageEditorData, TermsConditionService } from '@core';
import { TermsAndConditionsType } from '@models';
import { Observable } from 'rxjs';
import { MainLayoutService } from '../../../layout';

@Component({
  selector: 'lib-about-us',
  imports: [PageEditorComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
  standalone: true,
})
export class AboutUsComponent {
  readonly mainLayoutService = inject(MainLayoutService);
  readonly termsConditionService = inject(TermsConditionService);
  readonly type = TermsAndConditionsType.AboutUs;
  isLoadingData = signal(true);
  
  pageEditorData: PageEditorData = {
    arabic: { controller: formControl<string>(undefined, Validators.required), title: 'معلومات عنا' },
    english: { controller: formControl<string>(undefined, Validators.required), title: 'about us' },
  };

  constructor() {
    this.termsConditionService.getTermsAndConditionForAdmin(this.type).subscribe({
      next: (res) => {
        this.pageEditorData.arabic.controller.setValue(res.termsAndConditionsDTO.arabicValue);
        this.pageEditorData.english.controller.setValue(res.termsAndConditionsDTO.englishValue);
        this.isLoadingData.set(false);
      },
      error: (error) => {
        console.error('Error loading about us data:', error);
        snackbar$.error('Error loading about us data');
        this.isLoadingData.set(false);
      }
    });
  }

  updateFunction = (): Observable<string> => {
    return this.termsConditionService.updateTermsAndConditions({
      type: this.type,
      value: {
        arabic: this.pageEditorData.arabic.controller.value,
        english: this.pageEditorData.english.controller.value,
      },
    });
  }
}
